export const VideoData = [
    {
    id:1,
    videoUrl:"../../images/videos/vfilmmain.mp4",
    title:"North Point School Campus Tour",
    description1:"Explore our modern classrooms and facilities.",
    description2:"Our school provides quality education and a safe learning environment.",
    email:"northpointdehradun@gmail.com",
    buttonText:"Fullscreen",
    active:1,
    },
];

export const AboutData = {
  bannerImage: "../../images/aboutus/about.jpeg",
  headtitle: "Inspiring Excellence • Empowering Students • Building Futures",
  headdetails: [
      "AIMS - School management aims to create a safe, efficient and positive learning environment that fosters student success and institutional growth by coordinating human and material resources. Maintaining and improving the standards of teaching and learning. Ensuring a safe, orderly and encouraging atmosphere for students and teachers.",
      "OBJECTIVES - Setting up proper organized systems for planning, staffing and directing school activities. Ensuring the safety and security of children, including health programs. Implementing regulations, policies and curriculum standards.",
      "VISION - The school management’s vision is a future-oriented, aspirational statement defining the school’s long term goals. Engaging  parents, staff, and the local community to create a shared,and supportive environment. Focusing on the intellectual, emotional and social growth of students. Constantly assessing and updating strategies to meet evolving needs.",
  ],       
  principles: [
    {
      id: 1,
      title: "ACADEMIC INNOVATION FORUM",
      details: "The Academic Innovation Forum is a dynamic platform where students and educators come together to exchange ideas, explore new approaches to learning, and foster creativity in scholarship. It serves as a hub for collaboration, research, and forward-thinking discussions, inspiring learners to push boundaries and shape the future of education.",
      image: "../../images/aboutus/classroom.jpeg"
    },
    {
      id: 2,
      title: "LABORATORIES OF KNOWLEDGE & PROGRESS",
      details: "The Laboratories of Knowledge & Progress are vibrant spaces where curiosity meets innovation. Equipped with modern tools and resources, they provide students with hands-on opportunities to experiment, explore, and transform ideas into reality. These laboratories nurture critical thinking, creativity, and collaboration, empowering learners to push boundaries and contribute to the advancement of knowledge and society.",
      image: "../../images/aboutus/laboratory.jpeg"
    },
    {
      id: 3,
      title: "SPORTS HERITAGE AND INNOVATION CENTER",
      details: "Basketball is a dynamic and exhilarating sport that combines skill, teamwork, and strategy. Every dribble, pass, and shot builds anticipation, and when the ball swishes through the hoop, it brings not only joy but also a deep sense of accomplishment. Scoring a basket is more than just adding points—it’s a moment of pride, a contribution to the team’s success, and a source of inner satisfaction that fuels confidence and unity.",
      image: "../../images/aboutus/sports.jpeg"
    },
    {
      id: 4,
      title: "HERITAGE LEARNING EXCURSIONS",
      details: "Heritage Learning Excursions are immersive journeys designed to connect students with the rich cultural and historical legacy of our world. By visiting monuments, landmarks, and heritage sites, learners gain firsthand experiences that deepen their understanding of history, traditions, and architecture. These excursions spark curiosity, encourage reflection, and inspire respect for the past while nurturing a sense of responsibility toward preserving it for the future.",
      image: "../../images/aboutus/monument.jpeg"
    },
    {
      id: 5,
      title: "YOGA & MEDITATION PAVILION",
      details: "The Yoga & Meditation Pavilion is a serene space designed to nurture both body and mind. Here, students practice mindfulness, breathing techniques, and gentle movements that promote balance, focus, and inner peace. It offers a calm retreat from daily routines, encouraging self-awareness, emotional well-being, and holistic growth in a supportive environment.",
      image: "../../images/aboutus/yoga.jpeg"
    },
    {
      id: 6,
      title: "SCHOOL OF IMAGINATION AND EXPRESSION",
      details: "The School of Imagination and Expression is a creative haven where students explore the limitless power of ideas and artistry. Through painting, music, drama, writing, and design, learners are encouraged to express themselves freely while developing their artistic knowledge and skills. It is a space that nurtures originality, celebrates diverse talents, and inspires young minds to transform imagination into meaningful creations.",
      image: "../../images/aboutus/creative.jpeg"
    },
  ],

  managements: [
      {
        id: 1,
        title: "FOUNDER",
        name: "Late Mr. Khema Nand Sharma",
        image: "../../images/founders/Founder1.jpg",
        description:
        "Our Founder (Late Mr. K.N. Sharma) was the eldest son of Late Pandit Mani Ram Upadhyay and Shrimati Rama Devi Upadhyay. He started his career by serving in the Indian Army & served from 1940 to 1952 and was awarded the Jung-E-Inami for bravery during the 2nd World War in Burma. After that he joined the Police Services in the year 1953 and retired as DCIO, IB, Home Ministry in the year 1981. He was awarded the President’s Police Medal for Meritorious services while serving in the Intelligence Bureau. He was the prestigious post holder i.e. Editor and Adviser of Gorkhali Sudhar Sabha & Founder President of GORKHA DEMOCRATIC FRONT and District President of SAMAJWADI PARTY. He was a great Educationist, a man of discipline with a versatile quality, a man of vision, a religious and a spiritual thinker, a staunch follower of 'SWADHYAY'. His knowledge inspired him to compile a book named “Geeta Gyan” which has its own originality and depicts him a wonderful writer. He will always be remembered as a dynamic person and through gentleman."
        },
    
      {
        id: 2,
        title: "FOUNDER",
        name: "Late Mrs. Madhuri Upadhyay",
        image: "../../images/founders/Founder2.jpg",
        description:
          "Our Co-Founder & 1st Principal (Mrs. Madhuri Upadhyay) Late Mrs. Madhuri Upadhyay was the co-founder of the institution. She completed her higher education from Nainital and started her career in education in the year 1962, by joining Oak Grove school, Jharipani Mussoorie run by the Indian Railways. After serving for 24 years ,she took her voluntary retirement in the year 1986 and took over the charge as the first Principal of the Institution. The objective was to promote quality education along with value and ethics. She was known for her administrative skills. A great Academician and a discipline lover, under whose guidance the school rose from kindergarten to senior secondary school. The school will remain indebted for her valuable contribution."
        },
      {
        id: 3,
        title: "CHAIRMAN & MANAGING DIRECTOR",
        name: "Mr. Sodhanshu Upadhyay",
        image: "../../images/founders/Chairman.jpg",
        description:
          "Our institution is committed to excellence in education and character building. We strive to provide a nurturing environment where every student develops intellectual ability, moral strength, and leadership qualities..Greeting to All, 'If a man does not know to what part he is steering no wind is favorable. This was said by the ancient philosopher, Sencea.'"
      },
      {
        id: 4,
        title: "PRINCIPAL",
        name: "Dr. K. K. Upadhyay",
        image: "../../images/founders/Principal.jpg",
        description:
          "Dear Parents, Greetings! School is the base of every child’s foundation, where he is nurtured with both love and care, to bloom into colorful blossom and spread its fragrance far and wide. A child what he learns in his early years of schooling, builds his character and personality, which later reflects in its entire life."
      },
    ],
    aboutus: [
      "It is a Co-Education Day English Medium School from Play Group to Class-XIIᵗʰ.",
      "The School is Affiliated to The Council For ICSE (10+2), New Delhi, Established in the Year 1982 and is situated in peaceful area of Dehradun Cantt, Away from the Hustle & Bustle of the city.",
      "The Main object of the Academy is to prepare children through English Medium for the ICSE & ISC exams held by the Council for Indian School Certificate Examinations, New Delhi keeping Indian Cultural background so that the foundation of the young ones could properly be laid to enable them to sail smoothly in their further studies when they pass out from the institution. Besides imparting education, particular attention is paid to develop their moral discipline, good habits and cultivate good behavior and respectable attitude towards their elders.",
      "The institution was established in April 1982 by Late Mr. K. N. Sharma as a primary school to cater to the requirement of the local people. The first batch of ICSE(X) passed out. Since then there is no looking back & the school has been giving excellent board results & outstanding performances in other co-curricular activities within & outside the school.",
      "The institution is registered under the Societies Act 1880 and recognized by the State Govt. & Affiliated to the Council for Indian School Certificate Examination (ISC), New Delhi and run under the management of Board of Governors.",
    ],
};

export const classOptions = [
  "Play Group",
  "Nursery",
  "LKG",
  "UKG",
  "I",
  "II",
  "III",
  "IV",
  "V",
  "VI",
  "VII",
  "VIII",
  "IX",
  "X",
  "XI",
  "XII",
];

export const curriculumData = [
  {
    section: "intro",
    content:
      "The syllabus of study is the same as prescribed by the Council for ICSE and ISC through the medium of English with the following subject offered."
  },

  {
    section: "classGroup",
    title: "Class IX - X",
    blocks: [
      {
        type: "list",
        heading: "Compulsory Subjects",
        items: [
          "Hindi",
          "English",
          "Social Studies (History, Civics & Geography)"
        ]
      },
      {
        type: "list",
        heading: "Optional Subjects",
        items: [
          "Maths / Economics",
          "Computer Application / Economics / Art / Physical Education",
          "Commercial Studies / Science (Physics, Chemistry, Biology)",
          "EVS"
        ]
      },
      {
        type: "text",
        content:
          "Subject combination-Economics & Economic Application is not allowed."
      },
      {
        type: "highlight",
        content: "Pass Criteria: Five subjects including compulsory subjects."
      }
    ]
  },

  {
    section: "classGroup",
    title: "Class XI - XII",
    blocks: [
      {
        type: "list",
        heading: "Compulsory Subjects",
        items: [
          "English",
          "Physical Education",
        ]
      },
      {
        type: "grid",
        heading: "Streams",
        columns: [
          {
            title: "HUMANITIES",
            items: [
              "History", "Psychology", "Maths / Hindi",
              "Arts / Economics Arts", "EVS", "Home Science", "Geography"
            ]
          },
          {
            title: "SCIENCE",
            items: [
              "Physics", "Chemistry", "Maths / Hindi",
              "Biology / Computer Science",
              "Arts / Ecomimics"
            ]
          },
          {
            title: "COMMERCE",
            items: [
              "Accounts", "Commerce",
              "Maths / Hindi", "Economics / Computer Science",
              "Music / Home Science"
            ]
          }
        ]
      },
      {
        type: "highlight",
        content: "Pass Criteria: Five subjects including English."
      }
    ]
  },

  {
    section: "info",
    title: "Academic Session",
    items: [
      "The session begins in the 1st week of April. Divided into 2 terms",
      "1.	April to September",
      "2.	October to February"
    ]
  },

  {
    section: "info",
    title: "Examinations",
    items: [
      "Two terminal exams are held during the year (one after each term)",
      "1.	Half Yearly Exams, September",
      "2.	Annual Exams, March"
    ]
  },

  {
    section: "info",
    title: "Passing Marks Criteria",
    items: [
      "Class I-VIII - Average of both terminal exams.",
      "Class IX & XI - Needs to obtain passing marks in Annual Exams.",
      "In order to get promotion to the next class a child must not fail in two or more subjects.",
      "To opt for Science and Maths in Class IX minimum of 60% marks are required in Class VIII."
    ]
  },

  {
    section: "info",
    title: "Holidays",
    items: [
      "Summer: May (3rd week) – July (2nd week)",
      "Winter: Dec (4th week) – Jan (4th week)"
    ]
  },

  {
    section: "info",
    title: "School Hours",
    items: [
      "Summer: 7:45 AM",
      "Nursery & KG: 8:30 AM",
      "Winter: 8:45 AM – 2:00 PM",
      "Nursery & KG: 9:00 AM"
    ]
  }
];

export const SchoolUniform = [
  {
    category: "Boys",
    sections: [
      {
        season: "Summers",
        items: [
          "Grey Pant, White Shirt, Tie, Belt, Grey Socks and Black Shoes.",
          "Gray Track Suit, House T-Shirt with White P.T. Shoes and White Socks. (Wednesday)",
          "White Shirt, White Pant, Tie, Belt, White Socks with White P.T. Shoes. (Saturday)"
        ]
      },
      {
        season: "Winters",
        items: [
          "Grey Woolen Pant, White Shirt, Maroon Blazer with School Monogram, Tie, Belt, Gray Socks and Black Shoes.",
          "White Shirt, White Pant, Tie, Belt, White Socks with White P.T. Shoes. (Saturday)"
        ]
      }
    ]
  },
  {
    category: "Girls",
    sections: [
      {
        season: "Summers",
        items: [
          "Grey Skirt, White Shirt, Tie, Belt, Grey Socks and Black Shoes.",
          "Gray Track Suit, House T-Shirt with White P.T. Shoes and White Socks. (Wednesday)",
          "White Shirt, White Pant, Tie, Belt, White Socks with White P.T. Shoes. (Saturday)"
        ]
      },
      {
        season: "Winters",
        items: [
          "Grey Woolen Pant, White Shirt, Maroon Blazer with School Monogram, Tie, Belt, Gray Socks and Black Shoes.",
          "White Shirt, White Pant, Tie, Belt, White Socks with White P.T. Shoes. (Saturday)"
        ]
      }
    ]
  },
  {
    category: "PT Days & Saturdays",
    sections: [
      {
        season: "Summers",
        items: [
          "House color T-shirts",
          "White Shorts / Trousers / Skirts",
          "White School Socks, White Canvas Shoes",
          "House Patka (Sikh Boys)"
        ]
      },
      {
        season: "Winters",
        items: [
          "House Color T-shirts",
          "School Track Suit",
          "White School Socks / White Canvas Shoes",
          "White Patka (Sikh Boys)"
        ]
      }
    ]
  }
];

export const UniformRules = [
  "Drain Pipe, Bell Bottom Trousers are not allowed.",
  "Long Pointed Shoes, Shoes without laces, Shoes with Buckles are not allowed.",
  "Long Fashionable Hair is not allowed (except Sikh students).",
  "Rings, Bangles, Bracelets & Nose Studs should not be worn at school."
];

export const AcademicCalenderData = [
  {
    year: 2026,
    events: [
      { event_id: 1, lstno: 1, months: "April", lstyear: 2026, title: "School Reopening", day: "Thursday", date: "2nd April 2026", type: "activity" },
      { event_id: 2, lstno: 2, months: "April", lstyear: 2026, title: "Sanskrit Shlok / Flower Decoration ( VI-VIII )", day: "Wednesday", date: "22nd April 2026", type: "activity" },
      { event_id: 3, lstno: 3, months: "April", lstyear: 2026, title: "School Picnic / Educational Visit", day: "Wednesday - Thursday", date: "29th - 30th April 2026", type: "activity" },
      
      { event_id: 4, lstno: 4, months: "May", lstyear: 2026, title: "Notebook Inspection", day: "Friday - Saturday", date: "1st - 9th May 2026", type: "activity" },
      { event_id: 5, lstno: 5, months: "May", lstyear: 2026, title: "Class Test", day: "Friday - Friday", date: "15th - 22nd May 2026", type: "exam" },
      { event_id: 6, lstno: 6, months: "May", lstyear: 2026, title: "P.T.M.", day: "Saturday", date: "23rd May 2026", type: "meeting" },
      { event_id: 7, lstno: 7, months: "May", lstyear: 2026, title: "Extra Classes ( X & XII )", day: "Monday - Saturday", date: "25th May - 30th May 2026", type: "activity" },
      { event_id: 8, lstno: 8, months: "May", lstyear: 2026, title: "SUMMER VACATIONS", day: "Monday - Monday", date: "25th May - 13th July 2026", type: "holiday" },
      
      { event_id: 9, lstno: 9, months: "July", lstyear: 2026, title: "Staff Meeting", day: "Saturday", date: "11th July 2026", type: "meeting" },
      { event_id: 10, lstno: 10, months: "July", lstyear: 2026, title: "School Re-Opens", day: "Tuesday", date: "14th July 2026", type: "activity" },
      { event_id: 11, lstno: 11, months: "July", lstyear: 2026, title: "Project Assesement", day: "Monday - Thursday", date: "20th - 23rd July 2026", type: "activity" },
      { event_id: 12, lstno: 12, months: "July", lstyear: 2026, title: "S.U.P.W. & Community Service ( XII )", day: "Friday", date: "24th July 2026", type: "activity" },
      { event_id: 13, lstno: 13, months: "July", lstyear: 2026, title: "Investiture Ceremony ( Tentative )", day: "Monday", date: "27th July 2026", type: "activity" },
      { event_id: 14, lstno: 14, months: "July", lstyear: 2026, title: "Basketball Tournament ( Inter House )", day: "Tuesday - Thursday", date: "28th - 30th July 2026", type: "activity" },
      
      { event_id: 15, lstno: 15, months: "August", lstyear: 2026, title: "First Unit Test", day: "Monday - Saturday", date: "3rd - 8th August 2026", type: "exam" },
      { event_id: 16, lstno: 16, months: "August", lstyear: 2026, title: "Independence Day", day: "Saturday", date: "15th August 2026", type: "holiday" },
      { event_id: 17, lstno: 17, months: "August", lstyear: 2026, title: "Notebook inspection", day: "Monday", date: "17th August 2026 ONWARD", type: "activity" },
      { event_id: 18, lstno: 18, months: "August", lstyear: 2026, title: "English & Hindi Debate ( Inter House )", day: "Friday", date: "22nd August 2026", type: "activity" },
      { event_id: 19, lstno: 19, months: "August", lstyear: 2026, title: "Football Tournament ( Inter House )", day: "Monday - Thursday", date: "24th - 27th August 2026", type: "activity" },
      { event_id: 20, lstno: 20, months: "August", lstyear: 2026, title: "P.T.M.", day: "Saturday", date: "29th August 2026", type: "meeting" },
      
      { event_id: 21, lstno: 21, months: "September", lstyear: 2026, title: "Janmashtami Celebration", day: "Friday", date: "4th September 2026", type: "activity" },
      { event_id: 22, lstno: 22, months: "September", lstyear: 2026, title: "Teachers Day Celebration", day: "Saturday", date: "5th September 2026", type: "activity" },
      { event_id: 23, lstno: 23, months: "September", lstyear: 2026, title: "HALF YEARLY Examination Ist Pre Board ( X & XII )", day: "Monday - Monday", date: "14th - 28th September 2026", type: "exam" },
      
      { event_id: 24, lstno: 24, months: "October", lstyear: 2026, title: "Gandhi & Shastri Jayanti / Community Service", day: "Friday", date: "2nd October 2026", type: "activity" },
      { event_id: 25, lstno: 25, months: "October", lstyear: 2026, title: "Inter House Badminton Competition", day: "Tuesday - Friday", date: "5th - 8th October 2026", type: "activity" },
      { event_id: 26, lstno: 26, months: "October", lstyear: 2026, title: "P.T.M.", day: "Saturday", date: "9th October 2026", type: "meeting" },
      { event_id: 27, lstno: 27, months: "October", lstyear: 2026, title: "( Excursion IX - XII ) & Picnic ( Play Group - II ) / Educational Visit ( III - VIII )", day: "Saturday", date: "16th October 2026 TENTATIVE", type: "activity" },
      { event_id: 28, lstno: 28, months: "October", lstyear: 2026, title: "Dusshera Celebration", day: "Saturday", date: "17th October 2026" },
      { event_id: 29, lstno: 29, months: "October", lstyear: 2026, title: "English & Hindi Motivational", day: "Saturday", date: "23rd October 2026", type: "activity" },
      { event_id: 30, lstno: 30, months: "October", lstyear: 2026, title: "Fireless Cooking Competition ( III - VIII )", day: "Monday", date: "25th October 2026", type: "activity" },
      
      { event_id: 31, lstno: 31, months: "November", lstyear: 2026, title: "Notebook Inspection ( X - XII )", day: "Monday - Saturday", date: "2nd - 6th November 2026", type: "activity" },
      { event_id: 32, lstno: 32, months: "November", lstyear: 2026, title: "Rangoli Competition", day: "Saturday", date: "6th November 2026", type: "activity" },
      { event_id: 33, lstno: 33, months: "November", lstyear: 2026, title: "School Fete ( Children's Day )", day: "Saturday", date: "14th November 2026", type: "activity" },
      { event_id: 34, lstno: 34, months: "November", lstyear: 2026, title: "Inter House Dance Competition", day: "Saturday", date: "20th November 2026", type: "activity" },
      { event_id: 35, lstno: 35, months: "November", lstyear: 2026, title: "Annual Day", day: "Friday", date: "27th November 2026 TENTATIVE", type: "activity" },

      { event_id: 36, lstno: 36, months: "December", lstyear: 2026, title: "Internal Assessment I.C.S.E.", day: "Tuesday - Saturday", date: "1st - 12th December 2026", type: "activity" },
      { event_id: 37, lstno: 37, months: "December", lstyear: 2026, title: "Second Pre Board ( X & XII ) / HALF YEARLY ( XI )", day: "Tuesday - Saturday", date: "7th - 12th December 2026", type: "exam" },
      { event_id: 38, lstno: 38, months: "December", lstyear: 2026, title: "ISC Project Assessment", day: "TENTATIVE", date: "( As Per C.I.S.C.E. Schedule )", type: "activity" },
      { event_id: 39, lstno: 39, months: "December", lstyear: 2026, title: "Second Unit Test", day: "Monday - Saturday", date: "7th - 12th December 2026", type: "exam" },
      { event_id: 40, lstno: 40, months: "December", lstyear: 2026, title: "Class Photography", day: "Saturday", date: "12th December 2026", type: "activity" },
      { event_id: 41, lstno: 41, months: "December", lstyear: 2026, title: "Christmas Celebration ( Primary )", day: "Thursday", date: "24th December 2026", type: "activity" },
      { event_id: 42, lstno: 42, months: "December", lstyear: 2026, title: "P.T.M. ( 2nd Half )", day: "Thursday", date: "24th December 2026", type: "meeting" },
      { event_id: 43, lstno: 43, months: "December", lstyear: 2026, title: "WINTER VACATIONS", day: "Friday - Sunday", date: "25th December 2026 - 17th January 2027", type: "holiday" },
      
      { event_id: 44, lstno: 44, months: "January", lstyear: 2027, title: "Staff Meeting", day: "Saturday", date: "16th January 2027", type: "meeting" },
      { event_id: 45, lstno: 45, months: "January", lstyear: 2027, title: "School Re-Opens", day: "Monday", date: "18th January 2027", type: "activity" },
      { event_id: 46, lstno: 46, months: "January", lstyear: 2027, title: "Official Assembly of XII", day: "Wednesday", date: "20th January 2027 ( TENTATIVE )", type: "activity" },
      { event_id: 47, lstno: 47, months: "January", lstyear: 2027, title: "Farewell", day: "Saturday", date: "23rd January 2027 ( TENTATIVE )", type: "activity" },
      { event_id: 48, lstno: 48, months: "January", lstyear: 2027, title: "Republic Day Celebration", day: "Tuesday", date: "26th January 2027", type: "holiday" },

      { event_id: 49, lstno: 49, months: "February", lstyear: 2027, title: "Notebook Inspection", day: "Monday - Saturday", date: "1st - 6th February 2027", type: "activity" },
      { event_id: 50, lstno: 50, months: "February", lstyear: 2027, title: "Homage Day of Late Mr. K. N. Sharma & Late Mrs. M. Upadhyay", day: "Monday", date: "8th February 2027", type: "activity" },

      { event_id: 51, lstno: 51, months: "March", lstyear: 2027, title: "ANNUAL EXAMINATION", day: "Thursday - Saturday", date: "4th - 20th March 2027", type: "exam" },
      { event_id: 52, lstno: 52, months: "March", lstyear: 2027, title: "P.T.M. ( Annual Report Card Distribution )", day: "Saturday", date: "27th March 2027", type: "meeting" },

      { event_id: 53, lstno: 53, months: "April", lstyear: 2027, title: "School Re-Opens", day: "Thursday", date: "1st April 2027", type: "activity" },
    ],
  },
];

export const listHolidays = [{
  holiday_year: 2026,
  header: "List of Holidays Academic Year (2026-2027)",
  events: [
      
      { event_id: 1,start_date: "21-03-2026",end_date: "21-03-2026",months: "March",title: "Id-ul-Fitr",day: "Saturday",hdate: "21 March, 2026",lstyear: 2026},
      { event_id: 2,start_date: "26-03-2026",end_date: "26-03-2026",months: "March",title: "Ram Navmi",day: "Thursday",hdate: "26 March, 2026",lstyear: 2026},
      { event_id: 3,start_date: "30-03-2026",end_date: "30-03-2026",months: "March",title: "Mahavir Jayanti",day: "Monday",hdate: "30 March, 2026",lstyear: 2026},
      { event_id: 4,start_date: "03-04-2026",end_date: "03-04-2026",months: "April",title: "Good Friday",day: "Friday",hdate: "03 April, 2026",lstyear: 2026},
      { event_id: 5,start_date: "14-04-2026",end_date: "14-04-2026",months: "April",title: "Amdedkar Jayanti",day: "Monday",hdate: "14 April, 2026",lstyear: 2026},
      { event_id: 6,start_date: "28-05-2026",end_date: "28-05-2026",months: "May",title: "Id-ul-Zuha (Bakra Id)",day: "Tuesday",hdate: "28 May, 2026",lstyear: 2026},
      { event_id: 7,start_date: "26-06-2026",end_date: "26-06-2026",months: "June",title: "Moharram",day: "Friday",hdate: "26 June, 2026",lstyear: 2026},
      { event_id: 8,start_date: "16-07-2026",end_date: "16-07-2026",months: "July",title: "Harela",day: "Thursday",hdate: "16 July, 2026",lstyear: 2026},
      { event_id: 9,start_date: "15-08-2026",end_date: "15-08-2026",months: "August",title: "Independence Day",day: "Saturday",hdate: "15 August, 2026",lstyear: 2026},
      { event_id: 10,start_date: "26-08-2026",end_date: "26-08-2026",months: "August",title: "Eid-E-Milad",day: "Wednesday",hdate: "26 August, 2026",lstyear: 2026},
      { event_id: 11,start_date: "28-08-2026",end_date: "28-08-2026",months: "August",title: "Raksha Bandhan",day: "Saturday",hdate: "28 August, 2026",lstyear: 2026},
      { event_id: 12,start_date: "04-09-2026",end_date: "04-09-2026",months: "September",title: "Janmashtami",day: "Friday",hdate: "04 September, 2026",lstyear: 2026},
      { event_id: 13,start_date: "02-10-2026",end_date: "02-10-2026",months: "October",title: "Gandhi & Shastri Jayanti",day: "Friday",hdate: "02 October, 2026",lstyear: 2026},
      { event_id: 14,start_date: "20-10-2026",end_date: "20-10-2026",months: "October",title: "Dusshera",day: "Wednesday",hdate: "20 October, 2026",lstyear: 2026},
      { event_id: 15,start_date: "26-10-2026",end_date: "26-10-2026",months: "October",title: "Valmiki Jayanti",day: "Monday",hdate: "26 October, 2026",lstyear: 2026},
      { event_id: 16,start_date: "08-11-2026",end_date: "11-11-2026",months: "November",title: "Diwali Holidays",day: "Sunday-Wednesday",hdate: "08 - 11 November, 2026",lstyear: 2026},
      { event_id: 17,start_date: "16-11-2026",end_date: "16-11-2026",months: "November",title: "Chhat Pooja",day: "Monday",hdate: "16 November, 2026",lstyear: 2026},
      { event_id: 18,start_date: "19-11-2026",end_date: "19-11-2026",months: "November",title: "Egas",day: "Thursday",hdate: "19 November, 2026",lstyear: 2026},
      { event_id: 19,start_date: "24-11-2026",end_date: "24-11-2026",months: "November",title: "Guru Nanak Birthday",day: "Tuesday",hdate: "24 November, 2026",lstyear: 2026},
      { event_id: 20,start_date: "24-11-2026",end_date: "24-11-2026",months: "November",title: "Guru Teg Bahadur Shaheedi Diwas",day: "Tuesday",hdate: "24 November, 2026",lstyear: 2026},
      { event_id: 21,start_date: "25-12-2026",end_date: "25-12-2026",months: "December",title: "Christmas",day: "Friday",hdate: "25 December, 2026",lstyear: 2026},
      { event_id: 22,start_date: "26-01-2027",end_date: "26-01-2027",months: "January",title: "Republic Day",day: "Tuesday",hdate: "26 January, 2027",lstyear: 2026},
      { event_id: 23,start_date: "00-00-0000",end_date: "00-00-0000",months: "",title: "Maha Shivratri",day: "",hdate: "Holiday Subject to Government Gazette",lstyear: 2026},
      { event_id: 24,start_date: "00-00-0000",end_date: "00-00-0000",months: "",title: "Holi",day: "",hdate: "Holiday Subject to Government Gazette",lstyear: 2026},
      { event_id: 25,start_date: "00-00-0000",end_date: "00-00-0000",months: "",title: "Ram Navmi",day: "",hdate: "Holiday Subject to Government Gazette",lstyear: 2026},
      { event_id: 26,start_date: "00-00-0000",end_date: "00-00-0000",months: "",title: "Mahavir Jayanti",day: "",hdate: "Holiday Subject to Government Gazette",lstyear: 2026},
      { event_id: 27,start_date: "00-00-0000",end_date: "00-00-0000",months: "",title: "Good Friday",day: "",hdate: "Holiday Subject to Government Gazette",lstyear: 2026},
      { event_id: 28,start_date: "00-00-0000",end_date: "00-00-0000",months: "",title: "Guru Teg Bahadur Jayanti",day: "",hdate: "Holiday Subject to Government Gazette",lstyear: 2026},
      { event_id: 29,start_date: "00-00-0000",end_date: "00-00-0000",months: "",title: "Guru Govind Singh Birthday",day: "",hdate: "Holiday Subject to Government Gazette",lstyear: 2026},
      { event_id: 30,start_date: "00-00-0000",end_date: "00-00-0000",months: "",title: "Makar Sankranti",day: "",hdate: "Holiday Subject to Government Gazette",lstyear: 2026},
      ],
      Summer: "Summer Vacations - 25th May, 2026 (Monday) till 12th July, 2026 (Sunday). The school will be reopen on 13th July 2026 (Monday).",
      Winter: "Winter Vacations - 25th December, 2026 (Friday) till 14th January, 2027 (Sunday). The school will be reopen on 15th January 2027 (Monday).",
}];

export const ContactUsData = [
  {
    id: 1,
    schoolName: "North Point Children's Academy",
    address: "50, Tapkeshwar Road, Garhi, Dehradun Cantt, Uttarakhand",
    phone: ["+91-0135-3598009, +91-9837923036", "+91-8273065299"],
    email: "northpointdehradun@gmail.com",
    website: "www.northpointdoon.in",
    mapEmbed:
      "https://www.google.com/maps?q=Garhi%20Cantt%20Dehradun&output=embed",
  },
];

export const RegAdmissionData = [
  {
    title: "REGISTRATION & ADMISSION",
    content: [
      "Forms are available at the school office and website along with the prospectus.",
      "Minimum age for admission starts only after the child appears for the Assessment Test (U.K.G. onwards) held in March 3rd week.",
      "No admission will be considered until all requirements are met. Transfer certificate in original is required at the time of admission. Delay cases will be treated as provisional admission.",
      "Medical complications (if any) must be informed in writing.",
      "The Principal reserves the right to admit or refuse admission.",
      "Photocopy of Date of Birth certificate required.",
      "Three passport size photographs required.",
      "Parents must inform any change in address or phone number immediately."
    ]
  },
  {
    title: "PROVISIONAL ADMISSION",
    content: [
      "Students appearing for ICSE (Class X) may continue provisionally in Class XI until results are declared.",
      "If not continuing, parents must inform before 31st March.",
      "Otherwise, student remains on roll and must give one month withdrawal notice with fees.",
      "ICSE & ISC exam fees must be paid in July/August during form filling."
    ]
  },
  {
    title: "FEES",
    content: [
      "All fees are payable for 12 months and non-refundable.",
      "Additional charges may apply as needed."
    ]
  },
  {
    title: "WITHDRAWAL",
    content: [
      "Transfer Certificate applications must reach before 31st March.",
      "One month written notice required, otherwise fees must be deposited.",
      "TC issued only after clearing all dues.",
      "Withdrawal in second term requires full term fee payment."
    ]
  }
];

export const slideData = [
  {
    id: 1,
    type:"image",
    title: "Quality Education & Defining Future",
    description:
      "Our school is a vibrant hub of learning, featuring a spacious, green campus with modern classrooms and a large playground. It provides a balanced curriculum that combines academics with arts and sports.",
    image: "../../images/slides/build2.JPG", 
    buttonText: "Learn More",
    link: "/aboutus"
  },
  {
    id: 2,
    type:"video",
    title: "Modern Classrooms",
    description:
      "Smart boards, digital learning tools, and interactive teaching methods make every lesson engaging and effective.",
    video: "../../images/slides/schoolvideo2.mp4",
    buttonText: "Explore",
    link: "/facilities"
  },
  {
    id: 3,
    type:"image",
    title: "Sports & Fitness",
    description:
      "A large playground and dedicated sports facilities encourage teamwork, discipline, and physical well-being.",
    image: "../../images/slides/ban3.JPG",
    buttonText: "View Activities",
    link: "/activities"
  },
  {
    id: 4,
    type:"image",
    title: "Arts & Creativity",
    description:
      "Music, dance, and fine arts programs nurture creativity and self-expression among students.",
    image: "../../images/slides/ban4.jpg",
    buttonText: "Discover",
    link: "/arts"
  },
  {
    id: 5,
    type:"image",
    title: "Community & Values",
    description:
      "We instill values of respect, empathy, and responsibility, preparing students to be global citizens.",
    image: "../../images/slides/ban1.JPG",
    buttonText: "Know More",
    link: "/values"
  },
  {
    id: 6,
    type:"image",
    title: "Future Ready",
    description:
      "Career guidance, innovation labs, and technology integration prepare students for tomorrow’s challenges.",
    image: "../../images/slides/ban6.jpg",
    buttonText: "Explore Programs",
    link: "/frenchprog"
  },
  {
    id: 7,
    type:"image",
    title: "French Languages",
    description:
      "Empower your child with bilingual skills and build a strong foundation. Learn how to speak French the easy way.",
    image: "../../images/slides/ban7.JPG",
    buttonText: "Join Now",
    link: "/languages"
  }
];

export const whyNorthanian = [
  {
    id: 1,
    header: "Why To Be Northanian",
    imgpic: "../../images/slides/ban7.JPG",
    descr: [
      "1.	We have a team of adequality qualified and vastly experienced teachers.",
      "2.	For the past many years we have been proudly producing 100% results in ISC and ICSE.",
      "3.	We regularly conduct workshops to effectively guide senior students towards their career option.",
      "4.	We organize counselling session for the parents and students to establish good rapport between parents and children.",
      "5.	We have regular evaluation to help kid’s improvement.",
      "6.	The school prepares students well for competitive exams.",
      "7.	We provide assistance to students in selection of their subjects, streams, course and colleges across the country.",
      "8. Emphases are laid on regular parent teacher interaction for all round development of the child.",
      "9.	Affordable fees structure with various scholarships and concession policies as per school norm.",
      "10. No admission charges for the Defence wards.",
      "11. It’s a highly specialized place for children to learn and grow with harmony.",
      "12. For the all round development the teaching is focused on the cognitive skills and psychomotor of  the child.",
      "13. The school provides safe learning environment away from the noise and pollution of city.",
      "14. The school is committed to extra curricular activities like Music, Sports, Art, Craft, Drama, Yoga, Taekwondo and French classes.",
      "15. The school has excellent equipments and facilities like well stocked library, well equipped laboratories, yoga room, and music room.",
      "16. We focus on high standard of behavior and discipline.",
      "17. The school receives consistent and purposeful feedback that helps better understanding for student’s development and encouraging further growth.",
      "18. North Point Children’s Academy is a school with strong and supportive community that fosters a sense of belongingness and respect.",
    ]
  },
];

export const admissionFormData = {
  school: {
    name: "NORTH POINT CHILDREN’S ACADEMY",
    address: "50, Tapkeshwar Road, D.Dun Cantt",
    phone: "0135-3598009, 9456311713",
    affiliation: "Affiliated to the Council for ISCE (10+2), New Delhi"
  },

  fields: {
    officeUse: [
      "joinedOn",
      "admissionNo",
      "rollNo",
      "lfNo"
    ],

    student: [
      "name",
      "gender",
      "class",
      "dob",
      "birthPlace",
      "district",
      "state",
      "age",
      "nationality",
      "category"
    ],

    parents: [
      "fatherName",
      "motherName",
      "permanentAddress",
      "presentAddress",
      "phone",
      "mobile",
      "occupation"
    ]
  }
};